import React from "react";
import CardContainer from "../Containers/CardContainer";
import { Typography, Box } from "@mui/material";
import { RightTextBox, TextBox } from "../Styles/Box";
import { BackgroundBox } from "../Styles/Background";
import PagesHeader from "../Components/PagesHeader";
import workshop from "../Assets/workshop.webp";

export const Ateliers = () => {
    return (
        <BackgroundBox>
                <PagesHeader
                    image={workshop}
                    title={'Les ateliers'}
                    description={'Tout pour comprendre le vin, sa complexité et son histoire, découvrez, dégustez et savourez'}
                />
                <meta name="description" content="Atelier d'œnologie, assemblage et création de vin sur mesure, élaboration de cuvées à façon"/>
                <CardContainer typeProduit={'atelier'} />
        </BackgroundBox>
    );
}

export default Ateliers;